import { Badge } from '@/shared/components';
import type { DocumentTemplateSummary } from '../types/documentTemplates.types';
import { ownerLabel } from '../utils/templateOwnership';
import { DealerNamePlaceholder } from './DealerNamePlaceholder';

interface Props {
  template: DocumentTemplateSummary;
  dealerNames: ReadonlyMap<string, string>;
  isResolvingDealers?: boolean;
}

export function TemplateOwnerCell({ template, dealerNames, isResolvingDealers = false }: Props) {
  if (template.ownerDealerId === null) {
    return <Badge variant="info" size="xs">{ownerLabel(template, dealerNames)}</Badge>;
  }
  if (isResolvingDealers && !dealerNames.has(template.ownerDealerId)) {
    return <DealerNamePlaceholder />;
  }
  return <span className="text-sm">{ownerLabel(template, dealerNames)}</span>;
}
